/**
 * Cómo se llegó al importe guardado cuando el modal se abrió desde el enlace del correo
 * (Arca-Team/product#3). Sin enlace no se manda: ahí este desglose no aplica.
 * - `preset_delta`: se quedó con el importe que traía el correo (`current + amount`).
 * - `manual_slider`: lo cambió a mano después de abrirse con ese importe.
 */
export const CONTRIBUTION_ADJUSTMENT_METHODS = {
	PRESET_DELTA: 'preset_delta',
	MANUAL_SLIDER: 'manual_slider'
} as const;
export type ContributionAdjustmentMethod =
	(typeof CONTRIBUTION_ADJUSTMENT_METHODS)[keyof typeof CONTRIBUTION_ADJUSTMENT_METHODS];
